//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CardPropertyObjectItem',
  props: {
    property: {
      type: Object,
      default () {
        return {}
      }
    },
    propertyData: {
      type: Object,
      default () {
        return null
      }
    },
    showKey: {
      type: Boolean,
      default: false
    },
    optionAdditionalInfoFn: {
      type: Function,
      default () {
        return null
      }
    },
    additionalInBrackets: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasAccessToOpenCard: function () {
      const user = this.$store.getters.getUser
      const accessFn = this.property.componentProps && this.property.componentProps.hasAccess || null
      if (accessFn) {
        return accessFn.call(this, this.propertyData, user)
      }

      if (user.restrictedAccess && user.employee && user.employee.external) {
        return false
      }

      // TODO type_open_access проверка доступа к типам объектов
      if (this.propertyData && this.property) {
        if (this.property.type === 'sysobject' || this.property.type === 'sysobjects') {
          return false
        }
        return this.$d_hasObjectCardAccess(this.propertyData.type)
      }
      return false
    },
    isNotActual: function () {
      const markNotActual = this.property.componentProps && this.property.componentProps.markNotActual
      return !!markNotActual && this.propertyData && this.propertyData.actual === false
    },
    objectURL: function () {
      const propertyData = this.propertyData
      if (propertyData && this.hasAccessToOpenCard) {
        const objectURLFn = this.property.componentProps && this.property.componentProps.getObjectURL || null
        if (objectURLFn) {
          return objectURLFn.call(this, propertyData)
        }
        return this.$d_getUrlObjectCard(propertyData.id, propertyData.type)
      }
      return null
    }
  },
  methods: {
    onClick: function ($event) {
      if (this.hasAccessToOpenCard) {
        const objectURLFn = this.property.componentProps && this.property.componentProps.getObjectURL || null
        if (objectURLFn) {
          const objectURL = this.objectURL
          if (objectURL) {
            if ($event.ctrlKey) {
              window.open(objectURL, '_blank')
            } else {
              this.$router.push(objectURL)
            }
          }
        } else {
          const propertyData = this.propertyData
          this.$d_showObjectCard(propertyData.id, propertyData.type, $event.ctrlKey)
        }
      }
    }
  }
}
